import { SET_CENTER, SET_ZOOM, SET_BOUNDS, SET_CARD, RESET_ZOOM } from './mutation-types'
import { latLng } from 'leaflet'

const state = {
  zoom: { level: 3 },
  center: latLng(6.402648, 11.99707),
  bounds: {
    _northEast: {
      lat: 90,
      lng: 360,
    },
    _southWest: {
      lat: -90,
      lng: -360,
    },
  },
  card: {},
  reset: 0,
}

const mutations = {
  [SET_CENTER](state, payload) {
    state.center = latLng(payload)
  },
  [SET_ZOOM](state, payload) {
    state.zoom = payload
  },
  [SET_BOUNDS](state, payload) {
    state.bounds = payload
  },
  [SET_CARD](state, payload) {
    state.card = payload
  },
  [RESET_ZOOM](state) {
    if (!state.reset) {
      state.reset = 1
    } else {
      state.reset = 0
    }
  }
}

const actions = {
  setCenter({ commit }, payload) {
    commit(SET_CENTER, payload)
  },
  setZoom({ commit }, payload) {
    commit(SET_ZOOM, payload)
  },
  setBounds({ commit }, payload) {
    commit(SET_BOUNDS, payload)
  },
  setCard({ commit }, payload) {
    commit(SET_CARD, payload)
  },
  resetZoom({ commit }) {
    commit(RESET_ZOOM)
  }
}

const getters = {
  zoom: state => state.zoom,
  center: state => state.center,
  bounds: state => state.bounds,
  card: state => state.card,
  reset: state => state.reset,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
